import { render, staticRenderFns } from "./GoogleLogin.vue?vue&type=template&id=612dc284&scoped=true&"
import script from "./GoogleLogin.vue?vue&type=script&lang=js&"
export * from "./GoogleLogin.vue?vue&type=script&lang=js&"
import style0 from "./GoogleLogin.vue?vue&type=style&index=0&id=612dc284&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612dc284",
  null
  
)

export default component.exports